<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 p-4 shadow-lg rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray mb-1 text-xs font-semibold">
            Total Number of StaffS
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Number of Staff in Faculty of Medicine
          </h2>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap items-center">

      <div class="w-full lg:w-4/12 px-4 text-center">
        <div class="relative h-350-px">
          <canvas ref="chart_course"></canvas>
        </div>
        <div class="relative w-full p-3 max-w-full flex-grow flex-1">
          <h2 class="text-blueGray-700 text-xl font-semibold">
            All {{ teacher_arr.sum_all }} Staffs
          </h2>
          <h6 class="text-blueGray-400 text-sm mb-1 font-semibold">
            Staff in the Faculty of Medicine
          </h6>
        </div>
      </div>

      <div class="block overflow-x-auto w-full h-400-px lg:w-8/12 text-center rounded-lg shadow">

        <table class="items-center w-full bg-transparent border-collapse ">
          <thead class="sticky top-0">
            <tr>
              <th
                class="px-6 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold bg-blueGray-200 text-blueGray-500">
                Affiliation
              </th>
              <th
                class="px-6 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold bg-blueGray-200 text-blueGray-500">
                Number (Persons)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                Faculty of Medicine
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ teacher_arr.t_moror }}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                Other Faculty (Within PSU)
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ teacher_arr.t_psu }}
              </td>
            </tr>
            <tr v-for="(teacher_other, index) in teacher_other_arr" :key="index" v-show="teacher_other_arr.name_dept">
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                Other Institutions (Outside PSU) ({{ teacher_other.name_dept }})
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ teacher_other.sum }}
              </td>
            </tr>
            <tr v-for="(teacher_hospital, index) in teacher_hospital_arr" :key="index">
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                Affiliated Institutions ({{ teacher_hospital.name_dept }})
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ teacher_hospital.sum }}
              </td>
            </tr>
            <tr>
              <td colspan="2"  class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 font-semibold whitespace-nowrap text-left bg-blueGray-200">
                Affiliated Institutions (โรงพยาบาลชุมชน)
              </td>
            </tr>
            <tr v-for="(teacher_hospital_other, index) in teacher_hospital_other_arr" :key="index">
              <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{ teacher_hospital_other.name_dept }}
              </td>
              <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
                {{ teacher_hospital_other.sum }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import api from './../../services/student_services';

export default {
  data() {
    return {
      teacher_arr: [],
      teacher_list_arr: [],
      teacher_other_arr: [],
      teacher_hospital_arr: [],
      teacher_hospital_list_arr: [],
      teacher_hospital_other_arr: [],
    }
  },
  methods: {
    toggleAccordion(accordionNumber) {
      // กำหนดค่าให้กับคุณสมบัติที่เปิดหรือปิดของแต่ละ Accordion
      this.showAccordion[accordionNumber] = !this.showAccordion[accordionNumber];
    },
    async teacher_other() {
      api.teacher_other().then(async (result) => {
        this.teacher_other_arr = result.data;
      });
    },
    async teacher_hospital() {
      api.teacher_hospital().then(async (result) => {
        this.teacher_hospital_arr = result.data;
      });
    },
    async teacher_hospital_other() {
      api.teacher_hospital_other().then(async (result) => {
        this.teacher_hospital_other_arr = result.data;
      });
    },
    async teacher() {
      api.teacher().then(async (result) => {
        this.teacher_arr = result.data;
      });
    },
    async teacher_list() {
      api.teacher_list().then(async (result) => {
        this.teacher_list_arr = result.data;
        //console.log(result.data);       
        
        this.$nextTick(function () {
          const data_show = [];
          this.teacher_list_arr.forEach((teacher_list) => {
            data_show.push(teacher_list.t_hospital);
          });

          let config = {
            type: "doughnut",
            data: {
              labels: [
                'คณะแพทยศาสตร์',
                'คณะอื่น ๆ (ภายใน ม.อ.)',
                'ภายนอก ม.อ.',      
                'ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลหาดใหญ่',          
                'ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลยะลา',
                'ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลตรัง',
                'ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลสุราษฎร์ฯ',
                'ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลมหาราชนครศรีธรรมราช',                
                'ศูนย์แพทยศาสตรศึกษาชั้นคลินิก โรงพยาบาลสงขลา',     
                'โรงพยาบาลทุ่งสง จ.นครศรีธรรมราช',
                'โรงพยาบาลพัทลุง',      
                'โรงพยาบาลชุมชน',
              ],
              datasets: [
                {
                  data: data_show,
                  backgroundColor: ['#37BC9B', '#8CC152','#FCBB42','#FDC827', '#FE7A15', '#E9573F','#DA4453', '#D770AD','#967ADC', '#4A89DC','#3BAFDA', '#434A54','#656D78'],
                }
              ],
            },
            options: {
              maintainAspectRatio: false,
              responsive: true,
              legend: false,
              plugins: {
                datalabels: {
                  font: {
                    weight: 'bold',
                    size: 16
                  },
                  color: '#FFFFFF',
                  formatter: (data) => {
                    return data != 0 ? data : '';
                  }
                }
              }
            },
            plugins: [ChartDataLabels],
          };
          let ctx = this.$refs.chart_course.getContext('2d');
          window.myBar = new Chart(ctx, config);

        });
      });
    },

  }, created: async function () {
    await this.teacher(),
    await this.teacher_list(),
    await this.teacher_other(),
    await this.teacher_hospital(),
    await this.teacher_hospital_other()
  },
};
</script>
